import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * The "Urgent" marker on a high-priority job: a red pill with the urgent icon, shaped like the feed card's time pill and
 * sitting beside it on the card's top edge. It is text, not only a colour, so it reads the same to everyone. `label`
 * changes the word.
 */
@customElement('ns-urgent-marker')
export class NSUrgentMarker extends LitElement {
  @property({ type: String })
  label = 'Urgent';

  static styles = [
    css`
      :host {
        display: inline-flex;
        vertical-align: middle;
      }

      :host([hidden]) {
        display: none;
      }

      /* The feed card's time pill (.card .timer in ns-card-styles), in red */
      .marker {
        display: inline-flex;
        align-items: center;
        gap: var(--wa-space-3xs);
        padding: var(--wa-space-3xs) var(--wa-space-xs) var(--wa-space-3xs) var(--wa-space-3xs);
        border-radius: var(--wa-border-radius-l);
        background: var(--wa-color-danger-fill-loud);
        color: var(--wa-color-danger-on-loud);
        font-size: var(--wa-font-size-3xs);
        font-weight: 300;
        line-height: 1;
        white-space: nowrap;
      }

      .icon {
        width: 12px;
        height: 12px;
      }
    `,
  ];

  render() {
    return html`
      <span class="marker">
        <img class="icon" alt="" aria-hidden="true" src="/images/icons/urgent.svg" />
        ${this.label}
      </span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ns-urgent-marker': NSUrgentMarker;
  }
}
